var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16669 1.6665C13.3067 1.6665 16.6667 5.0265 16.6667 9.1665C16.6667 13.3065 13.3067 16.6665 9.16669 16.6665C5.02669 16.6665 1.66669 13.3065 1.66669 9.1665C1.66669 5.0265 5.02669 1.6665 9.16669 1.6665ZM9.16669 14.9998C12.3892 14.9998 15 12.389 15 9.1665C15 5.94317 12.3892 3.33317 9.16669 3.33317C5.94335 3.33317 3.33335 5.94317 3.33335 9.1665C3.33335 12.389 5.94335 14.9998 9.16669 14.9998ZM16.2375 15.059L18.595 17.4157L17.4159 18.5948L15.0592 16.2373L16.2375 15.059Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.3dd4966d83938298e1892edb6deb07c9.svg";
export { ForwardRef as ReactComponent };